import p1 from '../../assets/Gallery/428.webp';
// import p2 from '../../assets/Gallery/942.webp';
// import p3 from '../../assets/Gallery/5935.webp';
// import p4 from '../../assets/Gallery/05949.webp';
import p5 from '../../assets/Gallery/8566.webp';
import p6 from '../../assets/Gallery/IMG_0429.webp';
import p7 from '../../assets/Gallery/IMG_0430.webp';
import p8 from '../../assets/Gallery/IMG_0433.webp';
import p9 from '../../assets/Gallery/IMG_1061.webp';
import p10 from '../../assets/Gallery/IMG_1225.webp';
import p11 from '../../assets/Gallery/IMG_2780.webp';
import p12 from '../../assets/Gallery/MY_L8098.webp';
import p13 from '../../assets/Gallery/MY_L8335.webp';
import p14 from '../../assets/Gallery/MY_L8633.webp';
import p15 from '../../assets/Gallery/MY_L8634.webp';
import p16 from '../../assets/Gallery/MY_L8785.webp';
import p17 from '../../assets/Gallery/MY_L8914.webp';
import p18 from '../../assets/Gallery/MY_034.webp';
import p19 from '../../assets/Gallery/758.webp';
import p20 from '../../assets/Gallery/IMG_2799.webp';

const photos = [
  {
    photo: p1,
    size: 'small',
  },
  {
    photo: p9,
    size: 'large',
  },
  {
    photo: p15,
    size: 'small',
  },
  {
    photo: p20,
    size: 'small',
  },
  {
    photo: p5,
    size: 'small',
  },
  {
    photo: p6,
    size: 'small',
  },
  {
    photo: p7,
    size: 'medium',
  },
  {
    photo: p8,
    size: 'small',
  },
  {
    photo: p19,
    size: 'medium',
  },
  {
    photo: p10,
    size: 'medium',
  },
  {
    photo: p11,
    size: 'small',
  },
  {
    photo: p12,
    size: 'medium',
  },
  {
    photo: p13,
    size: 'small',
  },
  {
    photo: p14,
    size: 'medium',
  },
  {
    photo: p18,
    size: 'small',
  },
  {
    photo: p16,
    size: 'medium',
  },
  {
    photo: p17,
    size: 'small',
  },
];

export default photos;
